import { redirectToSubscriptionCheckout } from '../StripeClient';

const STRIPE_CHECKOUT_API = 'https://api.jashsoft.com/pay/checkout';

function buildCheckoutUrls() {
  const origin = window.location.origin;
  return {
    successUrl: `${origin}/?subscription=success&session_id={CHECKOUT_SESSION_ID}`,
    cancelUrl: `${origin}/?subscription=canceled`
  };
}

class CreateSubscriptionCheckout {
  action(modelInstance) {
    const { successUrl, cancelUrl } = buildCheckoutUrls();

    return fetch(STRIPE_CHECKOUT_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerEmail: modelInstance.emailAddress,
        successUrl,
        cancelUrl
      })
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Checkout session request failed');
      }
      return response.json();
    }).then((data) => {
      if (data.url) {
        window.location.href = data.url;
        return;
      }

      if (data.sessionId) {
        return redirectToSubscriptionCheckout(data.sessionId);
      }

      throw new Error('Checkout session response was invalid');
    });
  }
}

export default CreateSubscriptionCheckout;
